import { useEffect } from "react";

export function useAsyncEffect(
  effect: () => Promise<void>,
  deps: any[],
  destructor?: () => void,
) {
  useEffect(() => {
    effect();
    return destructor;
  }, deps);
}
